(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ib-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReviews(root) {
      if (!root || root.dataset.ibReady) return;
      root.dataset.ibReady = '1';
      var perPage = parseInt(root.dataset.perPage, 10) || 6;

      var more = root.querySelector('[data-ib-more]');
      if (more) {
        more.addEventListener('click', function () {
          var hidden = root.querySelectorAll('.ib-rev__card[hidden]');
          for (var i = 0; i < hidden.length && i < perPage; i++) hidden[i].removeAttribute('hidden');
          if (root.querySelectorAll('.ib-rev__card[hidden]').length === 0) more.parentNode.remove();
        });
      }

      var dlg = root.querySelector('[data-ib-lightbox]');
      if (!dlg) return;
      var img = dlg.querySelector('[data-ib-lb-img]');
      var cap = dlg.querySelector('[data-ib-lb-cap]');
      var photos = [];
      var seen = {};
      root.querySelectorAll('[data-ib-photo]').forEach(function (b) {
        var src = b.getAttribute('data-ib-photo');
        if (!seen[src]) { seen[src] = photos.length; photos.push({ src: src, cap: b.getAttribute('data-ib-caption') }); }
      });
      var idx = 0;
      function show(i) {
        idx = (i + photos.length) % photos.length;
        img.src = photos[idx].src;
        img.alt = 'Fotografie de la ' + photos[idx].cap;
        cap.textContent = photos[idx].cap + (photos.length > 1 ? '  ·  ' + (idx + 1) + ' / ' + photos.length : '');
      }
      function open(src) {
        show(seen[src] || 0);
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        document.documentElement.classList.add('ib-rev-lock');
      }
      function close() {
        if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
      }
      dlg.addEventListener('close', function () { document.documentElement.classList.remove('ib-rev-lock'); });
      root.querySelectorAll('[data-ib-photo]').forEach(function (b) {
        b.addEventListener('click', function () { open(b.getAttribute('data-ib-photo')); });
      });
      dlg.querySelector('[data-ib-close]').addEventListener('click', close);
      dlg.querySelector('[data-ib-prev]').addEventListener('click', function () { show(idx - 1); });
      dlg.querySelector('[data-ib-next]').addEventListener('click', function () { show(idx + 1); });
      if (photos.length < 2) dlg.classList.add('ib-rev__lightbox--single');
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(idx - 1);
        if (e.key === 'ArrowRight') show(idx + 1);
      });
    }

    function initAll() { document.querySelectorAll('[data-ib-reviews]').forEach(initReviews); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);

    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#recenzii"]');
      var target = document.getElementById('recenzii');
      if (a && target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
